import React, { useState } from 'react';
import { Button, Badge, Form } from 'react-bootstrap';
import { FaFilter, FaDownload } from 'react-icons/fa';
import './Filter.css';

const Filter = ({
  filter,
  count,
  darkMode,
  statesOptions = [],
  nearThreshold,
  onThresholdChange,
  onExport
}) => {
  const [filters, setFilters] = useState([
    false, // 0
    false, // 1 LOCAÇÃO
    false, // 2 SIMT
    false, // 3 BIMT
    false, // 4 CPMT
    false, // 5 EEMT
    false, // 6 ESMR
    false, // 7 ESTADOS
    false, // 8 CIDADES
    false, // 9 ONLINE
    false, // 10 999DRY
    false, // 11 CALIBRAÇÃO <=30 dias (legado)
    false, // 12 CALIBRAÇÃO EXPIRADA
    false, // 13 CALIBRAÇÃO EM BREVE
    false, // 14 NÃO LOCAÇÃO
    false  // 15 BLOQUEADOS
  ]);
  const [selectedState, setSelectedState] = useState('');

  const applyFilters = (nextFilters, stateValue = selectedState) => {
    setFilters(nextFilters);
    filter(nextFilters, '', '', stateValue);
  };

  const toggleFilter = (index, exclusiveWith = null) => {
    const next = [...filters];
    next[index] = !next[index];
    if (exclusiveWith !== null && next[index]) {
      next[exclusiveWith] = false;
    }
    applyFilters(next);
  };

  const handleStateChange = e => {
    const value = e.target.value;
    setSelectedState(value);
    applyFilters(filters, value);
  };

  const outlineVariant = darkMode ? 'outline-light' : 'outline-secondary';

  return (
    <div className={`map-filter-wrapper map-filter-calibration ${darkMode ? 'dark' : 'light'}`}>
      <div className="map-filter-container">
        <div className="calib-filter__header">
          <div className="calib-filter__title">
            <FaFilter className="calib-filter__icon" />
            <div>
              <h5>Filtros de calibração</h5>
              <p>Refine a visualização no mapa</p>
            </div>
          </div>
          <Badge
            bg={darkMode ? 'light' : 'secondary'}
            text={darkMode ? 'dark' : 'light'}
            className="map-count-badge"
          >
            {count} equipamentos
          </Badge>
        </div>

        <section className="calib-filter__section">
          <div className="filter-section-title">Tipo</div>
          <div className="calib-filter__chips">
            <Button
              size="sm"
              variant={filters[1] ? 'success' : outlineVariant}
              className="filter-button"
              onClick={() => toggleFilter(1, 14)}
              title="Mostrar apenas equipamentos de locação"
            >
              Locação
            </Button>
            <Button
              size="sm"
              variant={filters[14] ? 'success' : outlineVariant}
              className="filter-button"
              onClick={() => toggleFilter(14, 1)}
              title="Mostrar apenas equipamentos que não são de locação"
            >
              Não locação
            </Button>
            <Button
              size="sm"
              variant={filters[15] ? 'primary' : outlineVariant}
              className="filter-button"
              onClick={() => toggleFilter(15)}
              title="Mostrar apenas equipamentos bloqueados (daystoactivate = 0)"
            >
              Bloqueados
            </Button>
          </div>
        </section>

        <section className="calib-filter__section">
          <div className="filter-section-title">Status da calibração</div>
          <div className="calib-filter__chips">
            <Button
              size="sm"
              variant={filters[12] ? 'danger' : outlineVariant}
              className="filter-button"
              onClick={() => toggleFilter(12)}
              title="Mostrar apenas equipamentos com calibração expirada"
            >
              Expirada
            </Button>
            <Button
              size="sm"
              variant={filters[13] ? 'warning' : outlineVariant}
              className="filter-button"
              onClick={() => toggleFilter(13)}
              title={`Mostrar equipamentos com calibração entre 0 e ${nearThreshold} dias de vencer`}
            >
              Em breve (≤ {nearThreshold}d)
            </Button>
          </div>

          {typeof onThresholdChange === 'function' ? (
            <Form.Group className="calib-filter__threshold mt-2" controlId="nearThreshold">
              <Form.Label>Dias para “em breve”</Form.Label>
              <Form.Control
                type="number"
                min={1}
                max={365}
                size="sm"
                value={nearThreshold ?? 60}
                className={darkMode ? 'bg-dark text-light border-secondary' : ''}
                onChange={e => {
                  const value = Number(e.target.value);
                  if (!Number.isFinite(value)) return;
                  onThresholdChange(Math.min(365, Math.max(1, value)));
                }}
              />
            </Form.Group>
          ) : null}
        </section>

        <section className="calib-filter__section">
          <div className="filter-section-title">Estado</div>
          <Form.Select
            size="sm"
            value={selectedState}
            onChange={handleStateChange}
            className={darkMode ? 'bg-dark text-light border-secondary' : ''}
          >
            <option value="">Todos os estados</option>
            {statesOptions.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Form.Select>
        </section>

        <div className="calib-filter__footer">
          <Button
            size="sm"
            variant={darkMode ? 'outline-light' : 'outline-primary'}
            className="calib-filter__export d-flex align-items-center justify-content-center"
            disabled={!onExport || count === 0}
            onClick={() => onExport && onExport()}
            title="Baixar relatório CSV do filtro atual"
          >
            <FaDownload className="me-2" />
            Exportar CSV
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Filter;
